/**
 * @generated SignedSource<<8e79e188ab7e72c769a6287bb8ecbaf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssigneePickerSharedAssignee$data = {
  readonly __typename: string;
  readonly avatarUrl: string;
  readonly id: string;
  readonly isCopilot?: boolean;
  readonly login: string;
  readonly name: string | null | undefined;
  readonly profileResourcePath: string | null | undefined;
  readonly " $fragmentType": "AssigneePickerSharedAssignee";
};
export type AssigneePickerSharedAssignee$key = {
  readonly " $data"?: AssigneePickerSharedAssignee$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerSharedAssignee">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AssigneePickerSharedAssignee"
};

(node as any).hash = "d8c57c253a2f9513f6daa2dbe67a0412";

export default node;
